import { QuestionSlide as QuestionSlideType, QuestionsByDifficulty } from 'types'
import { Slide } from './types'

export const isAssessmentStage = (stage: string): boolean =>
  stage === 'Pre-Assessment' || stage === 'Post-Assessment'

const calculateSlideApproved = (questionsByDifficulty: QuestionsByDifficulty[] = []): boolean => {
  return questionsByDifficulty.every(
    diffQuestions => diffQuestions.questions.every(q => q.approved)
  )
}

export const calculateLessonUnapproved = (slides: Slide[]): number => {
  const assessmentQuestions = slides
    .filter(slide => slide.type === 'question' && isAssessmentStage(slide.learningStage || ''))
    .map(slide => slide.questionsByDifficulty as QuestionsByDifficulty[])[0] || []

  const nonAssessmentQuestions = slides
    .filter(slide => slide.type === 'question' && !isAssessmentStage(slide.learningStage || ''))
    .flatMap(slide => (slide.questionsByDifficulty as QuestionsByDifficulty[]))

  return [...assessmentQuestions, ...nonAssessmentQuestions]
    .flatMap(difficulty => difficulty.questions)
    .filter(q => !q.approved)
    .length
}

export const buildSlides = (numSlides: number, questionSlides: QuestionSlideType[]) => {
  const slides: Slide[] = Array(numSlides).fill(null).flatMap((_, i) => [
    { type: 'presentation' as const, index: i },
    ...questionSlides
      .filter((q: QuestionSlideType) => q.slide === i)
      .map((q: QuestionSlideType) => ({
        ...q,
        index: i,
        type: 'question' as const,
        id: crypto.randomUUID(),
        // Each assessment stage uses its OWN questions (with correct section-appended IDs)
        // Pre-Assessment questions have IDs like "abc123_Pre-Assessment"
        // Post-Assessment questions have IDs like "abc123_Post-Assessment"
        questionsByDifficulty: q.questionsByDifficulty,
        allApproved: calculateSlideApproved(q.questionsByDifficulty)
      }))
  ])

  return { slides }
}


